module.exports = __webpack_public_path__ + "img/extra-logo-black.040bd8f.svg";